import { FC } from 'react';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';
import Switch from '../switch';

import { sortFields } from '../../constants/sortFields';

export type SortOption = keyof typeof sortFields;
type ViewType = 'list' | 'map';

interface Props {
  propertiesTotal: number;
  roomsTotal: number;
  currentSortBy?: SortOption;
  currentViewType?: ViewType;
  changeSortBy: (direction: SortOption) => void;
  changeViewType: () => void;
  location?: string;
  sortOptions: SortOption[];
  loading: boolean;
}

const SearchResultFilters: FC<Props> = ({
  propertiesTotal,
  roomsTotal,
  currentSortBy = 'Distance',
  currentViewType = 'list',
  changeSortBy,
  changeViewType,
  location,
  sortOptions,
  loading = true,
}) => {
  const selectClasses = classNames({
    'select-list': true,
    'select-list--disabled': currentViewType === 'map',
  });

  return (
    <div className="search-results">
      <h2 className="search-results__heading">
        {I18n.t('search_results.title')}
      </h2>

      <div className="search-results__inner">
        <h3 className="search-results__info">
          {!loading && (
            <>
              {location && <span>{location}</span>}
              <span>
                {I18n.t('search_results.total_rooms', {
                  count: propertiesTotal > 0 ? roomsTotal : 0,
                })}
              </span>
              {propertiesTotal > 1 && (
                <span>
                  {I18n.t('search_results.total_properties', {
                    count: propertiesTotal,
                  })}
                </span>
              )}
            </>
          )}
        </h3>

        <div className="search-results__filters">
          <div className="search-results__filter-item search-results__filter-item--map-view">
            <Switch
              label={I18n.t('search_results.view_type.label')}
              toggled={currentViewType === 'map'}
              onSwitchChange={changeViewType}
            />
          </div>
          <div className="search-results__filter-item search-results__filter-item--sortby">
            <div className={selectClasses}>
              <select
                data-testid="sortField"
                value={currentSortBy || ''}
                onChange={e =>
                  changeSortBy(e.currentTarget.value as SortOption)
                }
                disabled={currentViewType === 'map'}
              >
                {!!sortOptions.length &&
                  sortOptions.map(field => (
                    <option key={field} value={field}>
                      {field}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultFilters;
